import { createContext } from 'react';

const ProgramContext = createContext({});
export default ProgramContext;
